import { axios, AxiosResponse } from "@sdk/axios";
import { SDKConfig } from "@sdk/default-sdk-config";
import { EntityServices } from "@sdk/utils/entity.service";
import { iLedgerTransaction } from "./ledger-transactions-models";

export type EditLedgerTransactionAnnotationsParams = {
  reference?: string;
  notes?: string;
};

export class LedgerTransactionsServices {
  configure(config: { basePath?: string; token?: string }) {
    Object.assign(this.config, config);
  }
  constructor(protected config: { basePath: string; token: string }) {
    this.ledgerTransactions.configure(config);
  }

  ledgerTransactions = new EntityServices<iLedgerTransaction>(
    SDKConfig,
    "ledger-transactions",
    {}
  );

  async editLedgerTransactionAnnotations(
    id: string,
    details: EditLedgerTransactionAnnotationsParams
  ): Promise<iLedgerTransaction> {
    const results: AxiosResponse<iLedgerTransaction> = await axios.patch(
      this.config.basePath + `/ledger-transactions/${id}/annotations`,
      details,
      {
        headers: {
          Authorization: this.config.token,
        },
      }
    );
    return results.data;
  }
}
